// this was previously using `getVersionName()` but that would make logs from old versions of the app not show up
// its intentionaly a fake token for now, the ultimate goal is to make it harder for the bots to encode the payload and send it to the server
export const FALL_LOGS_TOKEN = 'fake-tdr-logs-token';

export const LOGS_TOKEN_HEADER = 'X-LOGS-TOKEN';
